import type { DueSource } from "./dueItems.js";

/**
 * SYMBOLE DER QUELLEN (Spec „Texte und Symbole“; Übergang T-15 bis me-design sie liefert, Wunsch W11) — je Quelle ein Pfad
 * im 16er-Raster der me-design-Symbolsprache (viewBox 0 0 16 16, Strich 1,5, `currentColor`, ohne Füllung; Muster
 * `SYMBOL_PLUS` in `tickets/ticketSymbole.ts`). `DUE_SYMBOL_PATHS` trägt die Pfaddaten (für das sichtbare Symbol in Chip
 * und Zeile, `DueSymbol`), `DUE_SYMBOLS` denselben Pfad als SVG-Ausschnitt für `data-symbol` am `me-knopf`.
 */
export const DUE_SYMBOL_PATHS: Readonly<Record<DueSource, string>> = {
  // Eintrittskarte mit seitlichen Kerben.
  TICKET: "M2.5 4h11v2.5a1.5 1.5 0 0 0 0 3V12h-11V9.5a1.5 1.5 0 0 0 0-3z",
  // Raute (wie die Marke in der Zeitachse).
  MILESTONE: "M8 2.5 13.5 8 8 13.5 2.5 8z",
  // Preisschild mit Loch.
  OFFER: "M2.5 2.5h5.25l5.75 5.75-5.25 5.25-5.75-5.75zM5.5 5v1",
  // Beleg mit gezacktem Fuß und Zeilen.
  INVOICE: "M4 2h8v12l-2-1.25L8 14l-2-1.25L4 14zM6.25 5.5h3.5M6.25 8h3.5",
  // Kalenderblatt (Termine eines Zahlplans).
  PLANNED_CHARGE: "M2.5 3.5h11v10h-11zM2.5 6.5h11M5.5 2v3M10.5 2v3",
  // Geldschein mit Münze.
  SUPPLIER_PAYMENT: "M1.75 4.5h12.5v7H1.75zM8 6.25a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 1 0 0-3.5z",
  // Uhr (Frist).
  SUPPLIER_NOTICE: "M8 2.5a5.5 5.5 0 1 0 0 11a5.5 5.5 0 1 0 0-11zM8 5v3l2 1.5",
};

export const DUE_SYMBOLS: Readonly<Record<DueSource, string>> = Object.fromEntries(
  Object.entries(DUE_SYMBOL_PATHS).map(([s, d]) => [s, `<path d="${d}"/>`])) as Record<DueSource, string>;
